const tableStyles = {
  maxWidth: "890px",
  "th, td": {
    border: "none",
  },
  Tbody: {
    td: {
      color: "greyscale.700",
      textAlign: "right",
      py: 2,
    },
    tr: {
      "&:nth-of-type(2n)": {
        bg: "greyscale.200",
      },
    },
  },
};

export default tableStyles;
